export default __webpack_public_path__ + "static/media/logo.3dfb06a5.png";